var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetriveConfiguration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.717 38.443l-4.592-4.56c-6.238 4.624-10.292 11.97-10.292 20.33 0 2.09.254 4.149.76 6.08.38 1.584-1.52 2.724-2.66 1.552-4.686-4.845-7.6-11.432-7.6-18.715 0-7.98 3.484-15.105 8.994-20.045l-4.56-4.56c-1.014-1.013-.285-2.692 1.108-2.692h19.918c.887 0 1.584.697 1.584 1.584v19.918c.031 1.393-1.679 2.122-2.66 1.108z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/RetriveConfiguration.527303cf.svg";
export { SvgRetriveConfiguration as ReactComponent };